import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    show: false,
    text: '',
    title: ''
};
export const confirmationSlice = createSlice({
    name: 'confirmation',
    initialState,
    reducers: {
        show: (state, action) => {
            const { title, text } = action.payload;
            state.show = true;
            state.text = text;
            state.title = title;
        },
        close: (state) => {
            state.show = false;
        },
        accept: (state, action) => {
            state.show = false;
        }
    }
});
